if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();
    }

    get colorOptions () {
        return this.querySelectorAll('.product-card__swatches-container .swatches .swatch-color')
    }

    get selectedColorOption() {
        return this.querySelector('.product-card__swatches-container .swatches input:checked')
    }

    get colorImages () {
        return this.querySelectorAll('.product-card__image-wrapper .product-card__image .product-cover-image')
    }

    connectedCallback() {
        setTimeout(() => {
            this.initFirstOption()
            this.initFirstOptionImage()
            this.colorOptions?.forEach((item) => {
                item.addEventListener('click', this.handleOptionClick.bind(this))
            })
        }, 200)
    }


    initFirstOption () {
        const colorOptions = this.colorOptions
        if (!colorOptions?.length) return
        const firstOption = colorOptions[0]
        const parentElement = firstOption.parentElement 
        const inputDom = parentElement.querySelector('input')
        inputDom.setAttribute('checked', true)
    }

    initFirstOptionImage() {
        const colorImages = this.colorImages
        if (!colorImages?.length) return
        const firstOptionImage = colorImages[0]
        firstOptionImage.classList.remove('hidden')
    }

    handleOptionClick(e) {
        const target = e.target
        const parentElement = target.parentElement
        const inputDom = parentElement.querySelector('input')
        if (!inputDom) return
        if (this.selectedColorOption) {
            const selectedCoverDom = this.querySelector(`.product-card__image-wrapper .product-card__image .product-cover-image[alt='${this.selectedColorOption.value}']`)
            this.selectedColorOption.removeAttribute('checked')
            if (selectedCoverDom) {
                selectedCoverDom.classList.add('hidden')
            }
        }
        const firstCoverDom = this.querySelector(`.product-card__image-wrapper .product-card__image .product-cover-image[alt='first']`)
        if (firstCoverDom && !firstCoverDom.classList.contains('hidden')) {
            firstCoverDom.classList.add('hidden')
        }
        const newSelectedCoverDom = this.querySelector(`.product-card__image-wrapper .product-card__image .product-cover-image[alt='${inputDom.value}']`)
        if (newSelectedCoverDom) {
            newSelectedCoverDom.classList.remove('hidden')
        }
        inputDom.setAttribute('checked', true)
        const reversedLinks = this.querySelectorAll('.reversed-link')
        if (reversedLinks?.length) {
            reversedLinks.forEach((dom) => {
                let href = dom.href
                if (!href) return
                const questionIndex = href.indexOf('?')
                if (questionIndex > -1) {
                    href = href.slice(0, questionIndex)
                }
                dom.href = href + '?variant=' + inputDom.dataset.id
            })
        }
    }
 }
 customElements.define('card-product', CardProduct);
}